var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CrudList',{attrs:{"title":"Cupones de Usuario","storeName":"User_coupons","parentStoreName":"Coupons","parentUrlKey":"coupon_id","labelAddNew":"Añadir usuario al cupon","canAdd":true,"canEdit":false,"canDelete":true,"labelBack":"Atrás","sortable":"","breadcrumbs":[
      {
        text: 'Marketing y comunicación',
        disabled: false,
        href: '/admin/coupons'
      },
      {
        text: 'Cupones de Usuario',
        disabled: false,
        href: '#'
      },
      
    ]},scopedSlots:_vm._u([{key:"created_at",fn:function({item}){return [_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('p',[_vm._v(_vm._s(item.created_at ? _vm.formatDate(item.created_at) : ''))])])],1)]}},{key:"user_id",fn:function({ item }){return [_c('p',[_vm._v(" "+_vm._s(item && item.user_id?item.user_id.name:'')+" "+_vm._s(item && item.user_id?item.user_id.last_name:'')+" "),_c('br'),_vm._v(" "+_vm._s(item && item.user_id?item.user_id.email:'')+" ")])]}},{key:"coupon_id",fn:function({ item }){return [_c('p',[_vm._v(" "+_vm._s(item && item.coupon_id?item.coupon_id.title:'')+" "),_c('br'),_vm._v(" "+_vm._s(item && item.coupon_id?item.coupon_id.description:'')+" ")])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }